// src/components/Works.tsx
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { motion, AnimatePresence } from 'framer-motion';

import {IntroText, SubHeading, ContentParagraph, EmphasisText, StyledList, StyledListItem, CallToActionText} from '../styles/GlobalStyles'; // WorksStyles.tsxからエクスポートしたスタイルをインポート

// 各事業コンテンツコンポーネントをインポート
import AdvertisingContent from './works/AdvertisingContent';
import SystemDevelopmentContent from './works/SystemDevelopmentContent';
import EducationContent from './works/EducationContent';

const WorksPageContainer = styled(motion.div)`
  padding: 0px 20px;
  color: #f0f0f0;
  max-width: 900px;
  margin: 0 auto;
  font-family: 'Arial', sans-serif;
`;

const PageTitle = styled.h1`
  font-size: 2.8em;
  text-align: center;
  margin-bottom: 40px;
  color: cyan;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
`;

const TabsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  border-bottom: 2px solid #333;
`;

interface TabButtonProps {
  isActive: boolean;
}

const TabButton = styled.button<TabButtonProps>`
  padding: 12px 25px;
  font-size: 1.1em;
  font-weight: bold;
  cursor: pointer;
  background-color: transparent;
  color: ${(props) => (props.isActive ? 'cyan' : '#a0a0a0')};
  border: none;
  border-bottom: 3px solid ${(props) => (props.isActive ? 'cyan' : 'transparent')};
  margin-bottom: -2px; /* 親のborder-bottomと重なるように */
  transition: all 0.3s ease;
  outline: none;

  &:hover {
    color: cyan;
  }

  @media (max-width: 600px) {
    padding: 10px 15px;
    font-size: 1em;
  }
`;

const TabContent = styled(motion.div)`
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  min-height: 300px;
`;

export const ContentTitle = styled.h2`
  font-size: 2em;
  color: #00bcd4;
  margin-bottom: 25px;
  text-align: center;
`;

interface BusinessTabData {
    id: string;
    label: string; // タブのラベル
    pageTitle: string; // 各コンテンツエリアのH2タイトル
    ContentComponent: React.FC; // 表示するコンポーネント
  }

const businessTabsData: BusinessTabData[] = [
    {
      id: 'advertising',
      label: '広告事業',
      pageTitle: '広告運用代行サービス',
      ContentComponent: AdvertisingContent,
    },
    {
      id: 'system',
      label: 'システム開発',
      pageTitle: 'カスタムシステム開発',
      ContentComponent: SystemDevelopmentContent,
    },
    {
      id: 'seminar',
      label: '教育事業',
      pageTitle: '研修・セミナー講演',
      ContentComponent: EducationContent,
    },
  ];
const Works: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>(businessTabsData[0].id);

  const selectedTabData = businessTabsData.find((tab) => tab.id === activeTab);
  const CurrentContentComponent = selectedTabData?.ContentComponent; // オプショナルチェイニング
    if (!CurrentContentComponent) {
        return <div>コンテンツが見つかりません</div>; // コンポーネントが見つからない場合のフォールバック
    }
  return (
    <WorksPageContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <PageTitle>事業内容</PageTitle>

      <TabsContainer>
        {businessTabsData.map((tab) => (
          <TabButton
            key={tab.id}
            isActive={activeTab === tab.id}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </TabButton>
        ))}
      </TabsContainer>

      <AnimatePresence mode="wait">
        {selectedTabData && (
          <TabContent
            key={selectedTabData.id}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
          >
            <ContentTitle>{selectedTabData.pageTitle}</ContentTitle>
            <CurrentContentComponent /> {/* コンポーネントとしてレンダリング */}
          </TabContent>
        )}
      </AnimatePresence>
    </WorksPageContainer>
  );
};

export default Works;